module.exports = __webpack_public_path__ + "img/WeChatQRcode.92180773.jpg";